var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"choice-group",class:( _obj = {}, _obj['variant-'+_vm.variant] = _vm.variant, _obj )},_vm._l((_vm.choices),function(choice,index){return _c('div',{key:index,staticClass:"choice",class:{'active':choice.background===_vm.val},style:({'background': choice.background}),on:{"click":function($event){return _vm.makeActive(choice)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }